import { authWSClient } from 'WSClient/index';
import merge from 'Utils/lodash.merge';
import { SET_ALL } from './mutation-types';
import initialState from './state';

export default {
  async resetProfile({ commit }) {
    const initialStateData = initialState();
    // Profile model should be form model always
    const { default: BaseFormModel } = await import(/* webpackChunkName: 'BaseFormModel' */ 'Models/BaseFormModel');
    initialStateData.profileModel = new BaseFormModel();
    commit(SET_ALL, initialStateData);
  },
  async getProfileData({ commit, getters, state, dispatch }, { updateEmptyFieldsData } = {}) {
    if (getters.profileDataLoaded) return { data: getters.profileData };
    if (getters.profileDataLoading) return getters.profileDataPromise;
    const { default: ProfileModel } = await import(/* webpackChunkName: 'ProfileModel' */ 'Models/ProfileModel');
    const profileModel = new ProfileModel();
    commit(SET_ALL, { profileModel });
    // Trick for router dependency manager
    // It's require to do not load ProfileModel in main bundle
    // Otherwise profile model will load even user is not authorized
    const response = await profileModel.$dataLoadingPromise;
    state.profileDataPromiseTempResolve(response);
    if (updateEmptyFieldsData) {
      await dispatch('updateProfileData', {
        data: updateEmptyFieldsData,
        emptyFieldsOnly: true,
      });
    }
    return response;
  },
  getNewProfileData({ state }) {
    return state.profileModel._getData();
  },
  async updateMetaProfileData({ getters, dispatch }, { data }) {
    const { profileModel } = getters;
    const profileModelMeta = profileModel.metaData;
    merge(profileModelMeta, data);
    profileModel.meta = JSON.stringify(profileModelMeta);
    await dispatch('updateProfileData', {
      data: profileModel,
    });
  },
  updateProfileData({ getters }, { data, emptyFieldsOnly }) {
    const { profileModel } = getters;
    profileModel.$setAllDefinedFields(data, emptyFieldsOnly);
    // Do nothing if there is no changes
    if (!profileModel.$hasChangedData) return Promise.resolve();
    // Do not show success message
    profileModel.$skipShowMessageOnce = true;
    return profileModel.send(true);
  },
  updateProfileDataWithNoSend({ state }, data) {
    state.profileModel.$updateData(data);
  },
  setupNotification({ dispatch }) {
    authWSClient.subscribe(
      'refresh',
      null,
      message => dispatch('handleNotification', message),
    );
  },
  handleNotification({ dispatch }, message) {
    switch (message.channel) {
      case 'refresh': {
        dispatch('refreshData', message.message);
        break;
      }
      default: break;
    }
  },
  refreshData({ dispatch }, list = []) {
    list.forEach((item) => {
      if (item === 'investment') {
        dispatch('investment/getInvestmentList', { search: '' }, { root: true });
        dispatch('investment/refreshInvestmentsData', '', { root: true });
      } else if (item === 'accreditation-issues') {
        dispatch('portfolio/getAccountAccreditationIssueList', {}, { root: true });
      }
    });
  },
};
